import { Box, TableBody, useTheme } from "@mui/material"
import { PageDefaultSegmentWithHeader } from "@sis/react-library"
import { RPMTable } from "../../../shared/table/RPMTable"
import { ScheduleEventsHeader } from "./ScheduleEventsHeader"
import { ScheduleEventsActions } from "./ScheduleEventsActions";
import { sortItems, sortScheduleEvents } from "../../schedulePage/schedulePageHelper";
import { ScheduleEventsItem } from "./ScheduleEventsItem";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { useState } from "react";
import { rdsMeeting_Dto } from "../../../../interfaces/dtos/rdsMeeting";
import { rdsState } from "../../../../redux/rds/rdsSlice";
import { reloadScheduleEvents } from "../../../../redux/schedule/scheduleActions";
import { scheduleState } from "../../../../redux/schedule/scheduleSlice";
import { loadRdsEventStatusesFromMeeting } from "../../../../redux/rds/rdsActionsEventStatus";
import { segmentHeaderDefault } from "../../../../utils/commonUtils";

interface ScheduleEventsProps {
  meetings: rdsMeeting_Dto[];
  selectedMeetings: number[];
  meetingSectionOpen: boolean;
}

export const ScheduleEvents = ({
  meetings, selectedMeetings, meetingSectionOpen
}: ScheduleEventsProps) => {

  const theme = useTheme();
  const dispatch = useAppDispatch();
  const rds = useAppSelector(rdsState);
  const schedule = useAppSelector(scheduleState);

  const [sortBy, setSortBy] = useState(sortItems[0].key);

  const height = `calc(${meetingSectionOpen ? '50' : '100'}vh - ${meetingSectionOpen ? '160' : '320'}px)`;
  const transition = `height ${meetingSectionOpen ? '200' : '300'}ms ease-${meetingSectionOpen ? 'out' : 'in'}`;

  const filteredMeetings = meetings.filter((m) => selectedMeetings.some((sm) => sm === m.id));
  const filteredEvents = rds.rdsEvents.filter((e) => selectedMeetings.some((sm) => sm === e.meetingId));
  const sortedEvents = sortScheduleEvents(filteredEvents);

  const handleRefresh = () => {
    filteredMeetings.forEach(fm => {
      dispatch(reloadScheduleEvents(fm.id));
      dispatch(loadRdsEventStatusesFromMeeting(fm.id));
    });
  }

  return (
    <Box sx={{ paddingTop: 2 }}>
      <PageDefaultSegmentWithHeader
        id='schedule-events'
        headingText="Events"
        headingBackground={segmentHeaderDefault(theme)}
        headingColor={theme.palette.common.white}
        headingRightElement={
          <ScheduleEventsActions
            sortBy={sortBy}
            onSortChange={setSortBy}
            onRefresh={handleRefresh}
            loading={schedule.loading}
          />
        }
      >
        <RPMTable containerProps={{ sx: { height, transition } }} tableProps={{ stickyHeader: true }}>
          <ScheduleEventsHeader />
          <TableBody>
            {sortedEvents.map((event) =>
              <ScheduleEventsItem
                key={event.id}
                meeting={meetings.find(m => m.id === event.meetingId)!}
                event={event}
              />
            )}
          </TableBody>
        </RPMTable>
      </PageDefaultSegmentWithHeader>
    </Box>
  )
}